import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogContextService {
  private iltEventDialogOpen = new BehaviorSubject<boolean>(false);
  private cohortCalendarOpen = new BehaviorSubject<boolean>(false);
  private cohortProfileOpen = new BehaviorSubject<boolean>(false);

  public setIltEventDialogOpen(open: boolean): void {
    this.iltEventDialogOpen.next(open);
  }

  public isIltEventDialogOpen(): boolean {
    return this.iltEventDialogOpen.value;
  }

  public setCohortCalendarOpen(open: boolean): void {
    this.cohortCalendarOpen.next(open);
  }

  public isCohortCalendarOpen(): boolean {
    return this.cohortCalendarOpen.value;
  }

  public setCohortProfileOpen(open: boolean): void {
    this.cohortProfileOpen.next(open);
  }

  public isCohortProfileOpen(): boolean {
    return this.cohortProfileOpen.value;
  }
}
